import React from 'react';

export function convertTimetoAmPm(time){
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
}

export function getDateInFormat(inputDate, format){
    const date      = new Date(inputDate);
    const month     = date.getMonth()+1;
    const day       = date.getDate();
    const year      = date.getFullYear();
    const Hours     = date.getHours();
    const minutes   = date.getMinutes();
    const seconds   = date.getSeconds();

    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');

    let formattedDate = '';
    switch(format){
        case 'yyyy-mm-dd':
            formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
            break;
        case 'yyyy-mm-dd H:i:s':
            formattedDate = `${year}-${formattedMonth}-${formattedDay} ${Hours}:${minutes}:${seconds}`;
            break;
        case 'yyyy/mm/dd':
            formattedDate = `${year}/${formattedMonth}/${formattedDay}`;
            break;
        default:
            formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    }
    return formattedDate;
}

export function convertUTCtoLocalTime(inputDate, inputTimezone = false) {
    let date     = typeof inputDate != 'undefined' && inputDate != false ? inputDate : '';
    date         = new Date(date);
    let timeZone = (inputTimezone == false) ? false : inputTimezone;
    const event  = new Date(Date.UTC(
                                    date.getUTCFullYear(),
                                    date.getUTCMonth(),
                                    date.getUTCDate(), 
                                    date.getUTCHours(), 
                                    date.getUTCMinutes(), 
                                    date.getUTCSeconds())
                                );
    var convertedTime = event.toLocaleString('en-US', {timeZone: timeZone});
    
    if(typeof timeZone != 'undefined' && timeZone != false ) {
        return new Date(convertedTime); 
    } else {
        return date;
    }
}

function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  
export function getGMTTime(date = new Date()) {
    return [
      padTo2Digits(date.getUTCFullYear()),
      padTo2Digits(date.getUTCMonth()),
      padTo2Digits(date.getUTCDate()),
      padTo2Digits(date.getUTCHours()),
      padTo2Digits(date.getUTCMinutes()),
      padTo2Digits(date.getUTCSeconds()),
    ].join(':');
  }